// Google truncates SERP titles around 60 characters, so titles are clamped before render.
// A raw slice cuts mid-word ("...Here's What Actua"), so back off to the last word boundary
// and drop any separator left dangling at the end.

export const MAX_SEO_TITLE_LENGTH = 59;

export const clampSeoTitle = (value: string): string => {
  const trimmed = value.trim();
  if (trimmed.length <= MAX_SEO_TITLE_LENGTH) return trimmed;

  const sliced = trimmed.slice(0, MAX_SEO_TITLE_LENGTH);
  const lastSpace = sliced.lastIndexOf(" ");
  // Only respect the word boundary if it doesn't cost most of the title.
  const atBoundary = lastSpace > MAX_SEO_TITLE_LENGTH * 0.6 ? sliced.slice(0, lastSpace) : sliced;

  return atBoundary.replace(/[\s|\-–—:,;.]+$/, "").trimEnd();
};
